const KEY = "fcm_web_push_token";

export const getStoredFcmToken = () => localStorage.getItem(KEY) || "";
export const setStoredFcmToken = t => localStorage.setItem(KEY, t);
export const clearStoredFcmToken = () => localStorage.removeItem(KEY);
